

  <app-bandeau-titre-blagnac></app-bandeau-titre-blagnac>

  <div>
    <app-search-ticket-blagnac (newItemEventCamera)="addCamera($event)" (newItemEventProblem)="addProbleme($event)" (newItemEventStatus)="addStatus($event)"  (newItemEventInput)="eventInput($event)" (newAnnulerTout)="eventAnnuler($event)" (newCreateTicketEvent)="eventCreateTickets($event)"></app-search-ticket-blagnac>
  </div>
  <div>
    <app-display-ticket-blagnac [poste]="display" [item]="responsable" [camera]="camera" [problem]="problem" [status]="status" [LaunchDisplayTicket]="createTicket" (problemeSipproEvent)="getProblemSippro($event)" (problemeSnefEvent)="getProblemSnef($event)" (problemeMairieEvent)="getProblemMairie($event)" (problemeTousEvent)="getProblemTous($event)" ></app-display-ticket-blagnac>
  </div>
  <app-responsable-blagnac (newItemEvent)="addItem($event)" [annulerTOUS]="annulerTout" [allResponsableInput]="allResponsable" [problemTous]="problemTous" [problemSippro]="problemSippro" [problemSnef]="problemSnef" [problemMairie]="problemMairie"></app-responsable-blagnac>


  <div id="loading-maskTickets">
    <p class="textCreation">Mise a jour des pannes</p>
    <div  class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span  class="sr-only" id="loading"></span>
      </div>
    </div>
  </div>
